import * as React from 'react';
import Icons from "../../Icons";
import {UploadBtnProps} from "./UploadBtn";

export const UploadBtnByGallery = (props: UploadBtnProps) => {
  return (
    <div className={`btnImport mr1 mb1 p-2`} id={'btnImport-' + props.identifier} style={{ border: '1px solid #dee2e6'}}>
          <span className="d-none">
            <input onChange={(event) => props.onUpdateInput(event)} type="file" name="file" value={props.selectedFileName}
                   accept={props.authorizedFiles.join((','))} id={'file-' + props.identifier}/>
          </span>
      <div className="d-flex align-items-center flex-grow-1"
           style={{ height: '100%' }}>
        <label htmlFor={'file-' + props.identifier} id={'label-' + props.identifier}
               className={'label-file border-0 w100 h100 py-2 px-3 cursor-pointer m-0 importButton label-file-' +
                 props.marquageNom + '-' + props.surfaceId}>
          <Icons icon="file_upload" size={25} color="#000" className="mr-2"/>
          <span className={"d-flex align-items-center"}>Importer&nbsp;<span className="hide-for-small">un nouveau fichier</span></span>
        </label>
      </div>
    </div>
  );
}